import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { ITrade } from 'src/services/interfaces/trade/ITrade';
import { TradePhaseEnum } from 'src/services/interfaces/trade/TradePhaseEnum';
import Tooltip from "../../Tooltip/Tooltip";
import IGenericButtons from "../Interfaces/IGenericButtons";
import { TedsModal } from "./TedsModal";
import "./ViewTedButton.scss";

interface IViewTedButtonProps extends IGenericButtons {
  trade: ITrade;
}

export const ViewTedButton: React.FC<IViewTedButtonProps> = ({ trade }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    trade?.tradePricing?.pricing?.pricingDisbursements?.some(s => s?.tedDocumentKey) || trade.phase === TradePhaseEnum.Funding ? (
      <>
        <Tooltip text="Visualizar TEDs">
          <button className="view-ted btn" onClick={() => setShowModal(true)}>
            <FontAwesomeIcon icon={faEye} />
            Desembolsos
          </button>
        </Tooltip>
        <TedsModal trade={trade} visible={showModal} onClose={() => setShowModal(false)} />
      </>
    ) : null
  );
};



// WEBPACK FOOTER //
// ./src/components/common/GenericButtons/ViewTedButton/ViewTedButton.tsx